import { CouponMapper } from "@/domain/mappers";
import { CouponResponse } from "../dtos/responses";
import { CreateCouponRequest } from "../dtos/requests";
import { Coupon } from "@/domain/entities";
import moment from "moment";
import { CreateCouponInput } from "@/domain/dtos/inputs";

export class CouponMapperImpl implements CouponMapper<
  CouponResponse,
  CreateCouponRequest
> {
  toDomain(data: CouponResponse): Coupon {
    return {
      id: data.id,
      name: data.name,
      code: data.code,
      percent_off: `${data.percent_off}%`,
      active: data.active,
      redeem_by: data.redeem_by
        ? moment(data.redeem_by).format("DD/MM/YYYY")
        : "",
      max_redemptions_customers: data.max_redemptions_customers
        ? `${data.max_redemptions_customers}x`
        : "",
      is_expired: data.redeem_by ? moment(data.redeem_by).isBefore() : false,
    };
  }
  toRequest(data: CreateCouponInput): CreateCouponRequest {
    let values: CreateCouponRequest = {
      name: "Código Psiapp Pro",
      code: data.code,
      percent_off: parseInt(data.percent_off.replace("%", "")),
    };

    if (data?.redeem_by) {
      let rb = data.redeem_by.split("/");
      let redeemBy = `${rb[2]}-${rb[1]}-${rb[0]}`;
      values.redeem_by = redeemBy;
    }

    if (data.max_redemptions_customers) {
      values.max_redemptions_customers = data?.max_redemptions_customers
        ? parseInt(data?.max_redemptions_customers.replace("x", ""))
        : null;
    }

    return values;
  }
}
